import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SetOptionCommand from '../command/setOptionCommand';
import DropdownField from './dropdownField';

/**
 * @class SealingField
 */
export default class SealingField extends DropdownField {
    type = 'sealing';
    supports = 'supportsSealing';

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', this.onChangeSealing.bind(this));
    }

    onChangeSealing(event) {
        const target = $(event.target);
        const item = this.currentItem;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        const command = new SetOptionCommand(
            this.type,
            item,
            item.get('sealing'),
            target.data('item'),
        );

        history.addAndExecuteCommand(command);

        event.preventDefault();
    }

    /**
     * Update options with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const current = item.get('sealing');
        const options = [];

        item.sealingOptions.forEach((option) => {
            const key = `sealing_${item.type}_${option}`;

            options.push({
                key: option,
                value: this.translations[key] ? this.translations[key]() : key,
                active: option === current,
            });
        });

        this.setOptions(options);
    }

    /**
     * Check if item supports options dropdowns.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return Boolean(selectionLength === 1
            && item
            && item.hasParentItem()
            && item.getParentItem().get('hasSealing')
            && supportFlag
            && item[supportFlag]
            && item.supportsSealing);
    }
}
